<template>
  
  <div class="ui grid animated fadeIn">
    <div class="ui sixteen wide column">
      <div class="ui segment">
        <div class="ui form">
          <div class="fields">
            <div class="sixteen wide field">
              <label class="form-label">Modelo</label>
              {{ cert.certTemplate.name }}
            </div>                      
          </div>
          <div v-for="diagnosis in cert.diagnostics" class="fields m-t-20">
            <div class="sixteen wide field">
              <label class="form-label">{{ diagnosis.organ.description }}</label>
              <text-editor :readOnly="true" :contents="diagnosis.descriptionContents" />
            </div>
          </div>
          <div v-if="cert.commentsContents" class="fields">
            <div class="sixteen wide field">
              <label class="form-label">OBSERVAÇÕES</label>
              <text-editor :readOnly="true" :contents="cert.commentsContents" />
            </div>              
          </div>
        </div>
      </div>
    </div>
  </div>    

</template>

<script> 

  import TextEditor from "@/components/text-editor"

  export default {
    
    name: "CertDiagnosisTab",

    props: ["cert"],

    components: {
      TextEditor,
    },
  }

</script>
